import type { CSSProperties, JSX, ReactNode } from 'react';

interface IconButtonProps {
  onClick: () => void;
  ariaLabel: string;
  color?: string;
  size?: number;
  disabled?: boolean;
  children: ReactNode;
  style?: CSSProperties;
}

export function IconButton({
  onClick,
  ariaLabel,
  color,
  size = 32,
  disabled,
  children,
  style,
}: IconButtonProps): JSX.Element {
  const merged: CSSProperties = {
    width: size,
    height: size,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    border: 'none',
    background: 'transparent',
    color: color ?? 'currentColor',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 0.9,
    padding: 0,
    ...style,
  };

  return (
    <button type="button" onClick={onClick} aria-label={ariaLabel} disabled={disabled} style={merged}>
      {children}
    </button>
  );
}
